export const AuditsSelectStyle = {
    "backgroundColor": "#8CFAD0",
    "color": "#282832",
    "fontSize": "0.875rem",
    "fontWeight": 600,
    "borderRadius": 2,
    "padding": "8px 12px",
    "height": "45px",
    "width": "165px",
    "&:focus": {
        backgroundColor: "#8CFAD0",
    },
    "& .MuiSelect-select": {
        padding: 0,
    },
};

export const InspectionTypeDropdownTableFilterStyle = {
    "backgroundColor": "#8CFAD0",
    "color": "#282832",
    "fontSize": "0.875rem",
    "fontWeight": 600,
    "borderRadius": 2,
    "height": "45px",
    "width": "300px",
    "&:focus": {
        backgroundColor: "#8CFAD0",
    },
    "& .MuiSelect-select": {
        padding: 0,
    },
};

export const AuditsStatusSelectStyle = {
    "backgroundColor": "#8CFAD0",
    "color": "#282832",
    "fontSize": "0.8rem",
    "fontWeight": 600,
    "borderRadius": 2,
    "marginRight": "10px",
    "padding": "8px 12px",
    "height": "45px",
    "width": "160px",
    "&:focus": {
        backgroundColor: "#8CFAD0",
    },
    "& .MuiSelect-select": {
        padding: 0,
    },
};
